import Vue from 'vue'
import VueRouter from 'vue-router'

// 首页相关
// import Indexs from '../pages/index/index.vue'
import Home from '../pages/home/index.vue' /* 首页 */
// 我的相关
import Mine from '../pages/mine/index.vue' /* 我的 */
import ServiceOnline from '../pages/mine/ServiceOnline.vue' /* 客服列表 */
import ServicePage from '../pages/mine/ServicePage.vue' /* 客服详情界面 */
import Setting from '../pages/mine/Setting.vue' /* 设置 */
import Infomation from '../pages/mine/Infomation.vue' /* 基本信息 */
import Setname from '../pages/mine/Setname.vue' /* 修改姓名 */
import Language from '../pages/mine/Language.vue' /* 语言选择 */
import Setsex from '../pages/mine/Setsex.vue' /* 修改性别 */
import Recharge from '../pages/mine/Recharge.vue' /* 充值 */
import SetPayPassword from '../pages/mine/SetPayPassword.vue' /* 修改提现密码 */
import SetLoginPassword from '../pages/mine/SetLoginPassword.vue' /* 修改登录密码 */
import Notice from '../pages/mine/Notice.vue' /* 公告 */
import Setbank from '../pages/mine/Setbank' /* 银行卡设置 */
import BindCard from '../pages/mine/BindCard' /* 绑定银行卡界面 */
import Withdraw from '../pages/mine/Withdraw' /* 提现 */
import Personalreport from '../pages/mine/Personalreport' /* 个人报表 */
import GameRecord from '../pages/mine/GameRecord' /* 游戏记录 */
import WithdrawRecord from '../pages/mine/WithdrawRecord' /* 提现记录 */
import Details from '../pages/mine/details' /* 详情 */
import Lists from '../pages/list/index' /* 详情 */
import Listss from '../pages/list/index2' /* 详情 */
import myCard from '../pages/myCard/index' /* 我的钱包 */
// 选择相关
import Choose from '../pages/choose/index.vue'
import List from '../pages/choose/list.vue'
import Profile from '../pages/choose/profile.vue'
// 视频相关
import Video from '../pages/video/index.vue' /* 视频 */
import PlayVideo from '../pages/video/PlayVideo' /* 视频播放页面 */
// 游戏相关
import Game from '../pages/game/index.vue' /* 游戏 */
// 登录注册相关
import Login from '../pages/login/index.vue' /* 登录 */
import Register from '../pages/login/register.vue' /* 注册 */
// 抽奖相关
import Lottery from '../pages/lottery/index.vue' /* 抽奖 */
import Benefits from '../pages/benefits/index.vue' /* 抽奖 */
import BenefitsList from '../pages/benefits/list.vue' /* 抽奖 */
// 统一页面标题（提取为常量，方便后续修改）
const DEFAULT_PAGE_TITLE = 'ツヴァイ'

Vue.use(VueRouter)

// 修复1：统一路由路径为小写，删除冗余重定向，规范命名
const routes = [
  { path: '/', redirect: '/Home', meta: { title: DEFAULT_PAGE_TITLE } },
  // { path: '/Index', component: Indexs, meta: { title: DEFAULT_PAGE_TITLE } },
  { path: '/Home', name: 'Home', component: Home, meta: { title: DEFAULT_PAGE_TITLE } },
  { path: '/Choose', name: 'Choose', component: Choose, meta: { title: DEFAULT_PAGE_TITLE } },
  { path: '/List', name: 'List', component: List, meta: { title: DEFAULT_PAGE_TITLE } },
  { path: '/Profile', name: 'Profile', component: Profile, meta: { title: DEFAULT_PAGE_TITLE } },
  { path: '/Mine', name: 'Mine', component: Mine, meta: { title: DEFAULT_PAGE_TITLE } },
  { path: '/Video', name: 'Video', component: Video, meta: { title: DEFAULT_PAGE_TITLE } },
  { path: '/Game', name: 'Game', component: Game, meta: { title: DEFAULT_PAGE_TITLE } },
  { path: '/Login', name: 'Login', component: Login, meta: { title: DEFAULT_PAGE_TITLE } },
  { path: '/Register', name: 'Register', component: Register, meta: { title: DEFAULT_PAGE_TITLE } },
  { path: '/ServiceOnline', name: 'ServiceOnline', component: ServiceOnline, meta: { title: DEFAULT_PAGE_TITLE } },
  { path: '/ServicePage', name: 'ServicePage', component: ServicePage, meta: { title: DEFAULT_PAGE_TITLE } },
  { path: '/Setting', name: 'Setting', component: Setting, meta: { title: DEFAULT_PAGE_TITLE } },
  { path: '/Infomation', name: 'Infomation', component: Infomation, meta: { title: DEFAULT_PAGE_TITLE } },
  { path: '/Setname', name: 'Setname', component: Setname, meta: { title: DEFAULT_PAGE_TITLE } },
  { path: '/Language', name: 'Language', component: Language, meta: { title: DEFAULT_PAGE_TITLE } },
  { path: '/Setsex', name: 'Setsex', component: Setsex, meta: { title: DEFAULT_PAGE_TITLE } },
  { path: '/Recharge', name: 'Recharge', component: Recharge, meta: { title: DEFAULT_PAGE_TITLE } },
  { path: '/SetPayPassword', name: 'SetPayPassword', component: SetPayPassword, meta: { title: DEFAULT_PAGE_TITLE } },
  { path: '/SetLoginPassword', name: 'SetLoginPassword', component: SetLoginPassword, meta: { title: DEFAULT_PAGE_TITLE } },
  { path: '/Lottery', name: 'Lottery', component: Lottery, meta: { title: DEFAULT_PAGE_TITLE } },
  { path: '/Notice', name: 'Notice', component: Notice, meta: { title: DEFAULT_PAGE_TITLE } },
  { path: '/PlayVideo', name: 'PlayVideo', component: PlayVideo, meta: { title: DEFAULT_PAGE_TITLE } },
  { path: '/Setbank', name: 'Setbank', component: Setbank, meta: { title: DEFAULT_PAGE_TITLE } },
  { path: '/BindCard', name: 'BindCard', component: BindCard, meta: { title: DEFAULT_PAGE_TITLE } },
  { path: '/Withdraw', name: 'Withdraw', component: Withdraw, meta: { title: DEFAULT_PAGE_TITLE } },
  { path: '/PersonalReport', name: 'PersonalReport', component: Personalreport, meta: { title: DEFAULT_PAGE_TITLE } },
  { path: '/GameRecord', name: 'GameRecord', component: GameRecord, meta: { title: DEFAULT_PAGE_TITLE } },
  { path: '/WithdrawRecord', name: 'WithdrawRecord', component: WithdrawRecord, meta: { title: DEFAULT_PAGE_TITLE } },
  { path: '/Detail', name: 'Details', component: Details, meta: { title: DEFAULT_PAGE_TITLE } },
  { path: '/Lists', name: 'Lists', component: Lists, meta: { title: DEFAULT_PAGE_TITLE } },
  { path: '/Listss', name: 'Listss', component: Listss, meta: { title: DEFAULT_PAGE_TITLE } },
  { path: '/MyCard', name: 'MyCard', component: myCard, meta: { title: DEFAULT_PAGE_TITLE } },
  { path: '/BenefitsList', name: 'BenefitsList', component: BenefitsList, meta: { title: DEFAULT_PAGE_TITLE } },
  { path: '/Benefits', name: 'Benefits', component: Benefits, meta: { title: DEFAULT_PAGE_TITLE } }
];

// 生成路由实例
const router = new VueRouter({
    routes
})

// 修复2：优化标题设置，增加容错处理，避免 undefined 显示
router.beforeEach((to, from, next) => {
  // 优先取当前路由的 meta.title，没有则取默认标题，避免报错
  const pageTitle = to.meta.title || DEFAULT_PAGE_TITLE
  document.title = pageTitle
  next()
})

// 修复3：解决 VueRouter 3.x 重复点击路由报错的问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    // 只忽略路由重复跳转的错误，其他错误正常抛出
    if (err.name !== 'NavigationDuplicated') {
      throw err
    }
  })
}

export default router